import { render, staticRenderFns } from "./UserOnboarding.vue?vue&type=template&id=ddf9dd08&scoped=true"
import script from "./UserOnboarding.vue?vue&type=script&lang=js"
export * from "./UserOnboarding.vue?vue&type=script&lang=js"
import style0 from "./UserOnboarding.vue?vue&type=style&index=0&id=ddf9dd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf9dd08",
  null
  
)

export default component.exports